import React from "react";

import CodeEditor from "../../../../../components/elements/CodeEditor";

export default function SolutionEditor({
                                           workspace,
                                           solution,
                                           path,
                                           updateAtPath
                                       }) {

    const isProgram = workspace?.type === "program";
    const isWeb = workspace?.type === "web";

    const webEditors = {
        web_html: [
            {
                slot: "html",
                label: "HTML",
                language: "html"
            }
        ],

        web_html_css: [
            {
                slot: "html",
                label: "HTML",
                language: "html"
            },
            {
                slot: "css",
                label: "CSS",
                language: "css"
            }
        ],

        web_html_css_js: [            {
                slot: "html",
                label: "HTML",
                language: "html"
            },
            {
                slot: "css",
                label: "CSS",
                language: "css"
            },
            {
                slot: "js",
                label: "JavaScript",
                language: "javascript"
            }
        ]
    };

    const editors = isProgram
        ? [
            {
                slot: "main",
                label: null,
                language: workspace?.language
            }
        ]
        : isWeb
            ? webEditors[workspace?.template] || []
            : [];

    const getValue = (slot) => {
        return solution?.editors?.[slot] ?? "";
    };

    const updateValue = (slot, value) => {
        updateAtPath(
            [...path, "editors", slot],
            value
        );
    };

    return (
        <details className="border rounded-md bg-white" open={false}>

            <summary className="cursor-pointer p-4 font-semibold">
                Reference Solution
            </summary>

            <div className="p-4 space-y-4">

                {editors.map((editor) => (
                    <div key={editor.slot}>

                        {editor.label && (
                            <div className="font-medium mb-2">
                                {editor.label}
                            </div>
                        )}

                        <CodeEditor
                            language={editor.language}
                            value={getValue(editor.slot)}
                            onChange={(value) =>
                                updateValue(editor.slot, value)
                            }
                        />

                    </div>
                ))}

            </div>

        </details>
    );
}